import React, { Component, createContext } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import BNCClient from '@binance-chain/javascript-sdk'

import httpRequest, { NETWORK_ENV } from '../../utils/httpRequest'
import isElectron from '../../utils/isElectron'

const GATEWAY = httpRequest.getHttpBaseUri()
export const Context = createContext({})

class BNCClientProvider extends Component {
  static propTypes = {
    address: PropTypes.string.isRequired,
    children: PropTypes.element.isRequired,
  }

  constructor(props) {
    super(props)
    const source = isElectron() ? 68 : 1
    const client = (this._client = new BNCClient(GATEWAY, false, source))
    client.initChain()
    // client.chooseNetwork(NETWORK_ENV)
    if (NETWORK_ENV === 'mainnet') {
      client.chooseNetwork('mainnet')
    } else {
      client.chooseNetwork('testnet')
    }
  }

  componentWillUpdate({ address: nextAddress }) {
    const { address: thisAddress } = this.props
    if (thisAddress === nextAddress) return
    // TODO: NOTE: this will clear the account_number set in the client on address update
    console.log('BNCClientProvider: Account address has changed, clearing account_number.')
    this._client && this._client.account_number && (this._client.account_number = null)
  }

  render() {
    const { children } = this.props
    return <Context.Provider value={this._client}>{children}</Context.Provider>
  }
}

export const { Provider, Consumer } = Context

const mapStateToProps = ({ account: { address } }) => ({
  address,
})

export default connect(mapStateToProps)(BNCClientProvider)
